import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import cn from "classnames";

export const MakeImpact = ({ className, items }) => {
  return (
    <section className={cn(styles.MakeImpact, className)}>
      <Container>
        <div className={styles.columns}>
          {items?.map((item, idx) => (
            <div key={idx} className={styles.row}>
              {item.reverse ? (
                <>
                  <div className={styles.contentBlock}>
                    <h2
                      className={styles.title}
                      data-sourceflow-prop="title"
                      data-sourceflow-content-id={item.id}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <div
                      className={styles.desc}
                      data-sourceflow-prop="description"
                      data-sourceflow-content-id={item.id}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                  {item.image?.url && (
                    <img
                      className={styles.image}
                      src={item.image.url}
                      alt={item.image.alt || "Impact Image"}
                    />
                  )}
                </>
              ) : (
                <>
                  {item.image?.url && (
                    <img
                      className={styles.image}
                      src={item.image.url}
                      alt={item.image.alt || "Impact Image"}
                    />
                  )}
                  <div className={styles.contentBlock}>
                    <h2
                      className={styles.title}
                      data-sourceflow-prop="title"
                      data-sourceflow-content-id={item.id}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <div
                      className={styles.desc}
                      data-sourceflow-prop="description"
                      data-sourceflow-content-id={item.id}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default MakeImpact;
